import { Component, inject, Input, OnDestroy } from '@angular/core';
import { ControlValueAccessor, FormsModule, NgControl, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { of, Subscription, switchMap } from 'rxjs';

import { ButtonComponent } from '../button/button.component';
import { InputComponent } from '../input/input.component';
import { FormcontrolErrorsComponent } from '../standalone/formcontrol-errors/formcontrol-errors.component';

@Component({
  selector: 'bn-web-ui-custom-amount',
  templateUrl: './custom-amount.component.html',
  styleUrls: ['./custom-amount.component.scss'],
  imports: [FormsModule, ReactiveFormsModule, ButtonComponent, InputComponent, FormcontrolErrorsComponent],
})
export class CustomAmountComponent implements ControlValueAccessor, OnDestroy {
  ngControl = inject(NgControl, { self: true });

  @Input()
  public inputName?: string;

  @Input()
  public predefinedAmounts: number[] = [10, 25, 50, 100, 250, 500, 1000, 2000];

  @Input()
  public minAmount?: number;

  @Input()
  public maxAmount?: number;

  public isDisabled = false;
  public isTouched = false;
  public showOther = false;

  public form = new UntypedFormGroup({
    amount: new UntypedFormControl(),
  });

  private subscriptions: Subscription = new Subscription();

  private onTouched: () => void = () => ({});
  private onChange: () => void = () => ({});

  constructor() {
    const ngControl = this.ngControl;

    if (ngControl) this.ngControl.valueAccessor = this;
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public writeValue(val: number): void {
    if (val) {
      this.form.controls.amount.setValue(val);
    }
  }

  public registerOnChange(fn: (value: number) => void): void {
    this.subscriptions.add(
      this.form.valueChanges.pipe(switchMap((data) => of(data.amount))).subscribe((data) => {
        if (!this.isTouched) {
          this.onTouched();

          this.isTouched = true;
        }

        fn(data);
      }),
    );
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  public onOtherClick(): void {
    this.showOther = true;
  }

  public onAmountChange(amount: number): void {
    this.showOther = false;

    this.form.controls.amount.setValue(amount);
  }
}
